module.exports = __webpack_public_path__ + "img/talkizy-logo.8c48355c.png";